import { Spinner } from "react-bootstrap";

export default function Loading({show}) {
  if (show) {
    return (
      <Spinner animation="border" role="status" variant="primary" />
    );
  } else {
    return (<></>);
  }
}